import React, { useState } from "react"
import Select from "react-select";

function SelectOPOArchive(props) {
    const uniqueId = `select-opo-archive${Math.random()}`;
    const archives = props.archives?.map(x => ({ label: x.name, value: x.release }));
    const Host = process.env.REACT_APP_API_HOST;

    const [isVisible, setIsVisible] = useState(false);
    const [downloadLink, setDownloadLink] = useState();

    const _onChange = (event) => {
        setIsVisible(true);
        setDownloadLink(`${Host}/documents/opo/${props.opoCode}/${event.value}`);
    }

    return (
        <>
            <div id={`label-${uniqueId}`} htmlFor={uniqueId} className="select-opo-archive-text">
                You can also download historic archived PDF reports here:
            </div>
            <div className="opo-archive">
                <Select
                    id={uniqueId}
                    className="select-archive"
                    classNamePrefix="select"
                    isClearable={false}
                    isSearchable={true}
                    name="archives"
                    options={archives}
                    onChange={_onChange}
                    aria-labelledby={`label-${uniqueId}`}
                />
                {isVisible && <a className="opo-archive-download" href={downloadLink}>Download</a> }
            </div>
        </>
    );
}

export default SelectOPOArchive;